module.exports = __webpack_public_path__ + "img/gocement.bb50fe5c.png";